<h5>Social Links</h5>
<div class="row">
    <div class="col-2">
        <mat-form-field class="example-full-width mb-3">
            <mat-label>FaceBook Url</mat-label>
            <input matInput #facebookInput [formControl]="facebookControl" (change)="inputChangeFacebook($event)" />
            <i class=" fab fa-facebook-square" matSuffix></i>
        </mat-form-field>
    </div>
    <div class="col-2">
        <mat-form-field class="example-full-width mb-3">
            <mat-label>Twitter Username</mat-label>
            <input matInput #twitterInput [formControl]="twitterControl" (change)="inputChangeTwitter($event)" />
            <i class="fab fa-twitter" matSuffix></i>
        </mat-form-field>
    </div>
    <div class="col-2">
        <mat-form-field class="example-full-width mb-3">
            <mat-label>Intagram Username</mat-label>
            <input matInput #instagramInput [formControl]="instagramControl"
                (change)="inputChangeInstagramUserName($event)" />
            <i class="fab fa-instagram" matSuffix></i>
        </mat-form-field>
    </div>
    <div class="col-2">
        <mat-form-field class="example-full-width mb-3">
            <mat-label>Snapchat Username</mat-label>
            <input matInput #snapchatInput [formControl]="snapchatControl"
                (change)="inputChangeSnapchatUsername($event)" />
            <i class="fab fa-snapchat" matSuffix></i>
        </mat-form-field>
    </div>
    <div class="col-2">
        <mat-form-field class="example-full-width mb-3">
            <mat-label>linked Username</mat-label>
            <input matInput #twitterInput [formControl]="twitterControl" (change)="inputChangeLinkedIn($event)" />
            <i class="fab fa-linkedin" matSuffix></i>
        </mat-form-field>
    </div>
</div>